import { START, SUCCESS, ERROR } from "../../actions/types";

export const reduxActionsFactory = (actionType) => {
  return {
    'start': payload => ({
      type: `${actionType}${START}`,
      payload
    }),
    'success': payload => {
      return {
        type: `${actionType}${SUCCESS}`,
        payload
      };
    },
    'error': payload => {
      return {
        type: `${actionType}${ERROR}`,
        payload
      };
    }
  };
};

export const createActionWithPayload = type => payload => ({
  type,
  payload
});